import React, { useState, useEffect } from 'react';
import { authService } from '../../services/authService';

export const EnhancedLogin = ({ onLogin }) => {
  const [loginType, setLoginType] = useState('phone'); // 'phone', 'password'
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [passwordPhone, setPasswordPhone] = useState(''); // 密码登录的手机号
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(''); // 新增：成功消息
  const [countdown, setCountdown] = useState(0);
  const [isSending, setIsSending] = useState(false);

  // 处理倒计时
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  // 自动关闭提示
  useEffect(() => {
    let timer;
    if (error || success) {
      timer = setTimeout(() => {
        setError('');
        setSuccess('');
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [error, success]);

  // 处理手机号输入变化
  const handlePhoneChange = (e) => {
    const inputValue = e.target.value;
    // 只保留数字
    const numericValue = inputValue.replace(/\D/g, '');
    setPhone(numericValue);
  };

  // 处理密码登录手机号输入变化
  const handlePasswordPhoneChange = (e) => {
    const inputValue = e.target.value;
    // 只保留数字
    const numericValue = inputValue.replace(/\D/g, '');
    setPasswordPhone(numericValue);
  };

  // 验证手机号
  const validatePhone = (phoneNumber) => {
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phoneNumber);
  };

  // 发送验证码
  const handleSendCode = async () => {
    if (!validatePhone(phone)) {
      setError('请输入有效的手机号码');
      return;
    }

    setError('');
    setIsSending(true);

    try {
      // 调用发送验证码的服务
      await authService.sendVerificationCode(phone);
      setCountdown(60); // 60秒倒计时
      setSuccess('验证码发送成功');
    } catch (err) {
      setError(err.message || '发送验证码失败，请稍后再试');
    } finally {
      setIsSending(false);
    }
  };

  // 处理登录表单提交
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      let user;

      if (loginType === 'phone') {
        // 手机验证码登录
        if (!validatePhone(phone)) {
          setError('请输入有效的手机号码');
          return;
        }

        if (!verificationCode) {
          setError('请输入验证码');
          return;
        }

        user = await authService.loginWithPhone(phone, verificationCode);
      } else if (loginType === 'password') {
        // 账号密码登录
        if (!validatePhone(passwordPhone)) {
          setError('请输入有效的手机号码');
          return;
        }

        if (!password) {
          setError('请输入密码');
          return;
        }

        user = await authService.loginWithPhonePassword(passwordPhone, password);
      }

      setSuccess('登录成功');
      onLogin(user);
    } catch (err) {
      setError(err.message || '登录失败，请检查输入信息');
    }
  };
  
  // 处理微信登录
  const handleWechatLogin = () => {
    // 这里应该实现微信登录逻辑
    alert('微信登录功能开发中');
  };

  return (
    <div className="elegant-auth-form">
      {/* 顶部提示弹窗 */}
      {error && <div className="elegant-auth-toast error">{error}</div>}
      {success && <div className="elegant-auth-toast success">{success}</div>}
      
      <div className="elegant-auth-tabs">
        <button 
          className={`elegant-auth-tab ${loginType === 'phone' ? 'active' : ''}`}
          onClick={() => {
            setLoginType('phone');
            setError('');
          }}
        >
          <i className="elegant-auth-icon phone-icon"></i>
          手机号登录
        </button>
        <button 
          className={`elegant-auth-tab ${loginType === 'password' ? 'active' : ''}`}
          onClick={() => {
            setLoginType('password');
            setError('');
          }}
        >
          <i className="elegant-auth-icon password-icon"></i>
          密码登录
        </button>
      </div>

      <form onSubmit={handleSubmit} className="elegant-auth-form-fields">
        {loginType === 'phone' ? (
          <>
            <div className="elegant-auth-group">
              <div className="elegant-auth-input-wrapper">
                <i className="elegant-auth-input-icon phone-icon"></i>
                <input
                  type="text"
                  className="elegant-auth-input"
                  placeholder="请输入手机号"
                  value={phone}
                  onChange={handlePhoneChange}
                  required
                />
              </div>
            </div>
            <div className="elegant-auth-group code-group">
              <div className="elegant-auth-input-wrapper">
                <i className="elegant-auth-input-icon code-icon"></i>
                <input
                  type="text"
                  className="elegant-auth-input"
                  placeholder="验证码"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  required
                />
              </div>
              <button
                type="button"
                className={`elegant-auth-code-btn ${countdown > 0 ? 'disabled' : ''}`}
                onClick={handleSendCode}
                disabled={countdown > 0 || isSending}
              >
                {countdown > 0 ? `${countdown}秒后重发` : '获取验证码'}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="elegant-auth-group">
              <div className="elegant-auth-input-wrapper">
                <i className="elegant-auth-input-icon phone-icon"></i>
                <input
                  type="text"
                  className="elegant-auth-input"
                  placeholder="请输入手机号"
                  value={passwordPhone}
                  onChange={handlePasswordPhoneChange}
                  required
                />
              </div>
            </div>
            <div className="elegant-auth-group">
              <div className="elegant-auth-input-wrapper">
                <i className="elegant-auth-input-icon lock-icon"></i>
                <input
                  type="password"
                  className="elegant-auth-input"
                  placeholder="请输入密码"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
          </>
        )}
        
        <button type="submit" className="elegant-auth-submit">
          登录（Log In）
        </button>
        
        <div className="elegant-auth-divider">
          <span>或</span>
        </div>
        
        <div className="elegant-auth-social-row">
          <button type="button" className="elegant-auth-wechat-btn" onClick={handleWechatLogin}>
            使用微信登录
          </button>
          <button type="button" className="elegant-auth-qq-btn" onClick={() => alert('QQ登录功能开发中')}>
            使用QQ登录
          </button>
        </div>
        
        <div className="elegant-auth-agreement">
          注册登录即代表同意 <a href="/agreement" target="_blank" rel="noopener noreferrer">用户协议</a> 与 <a href="/privacy" target="_blank" rel="noopener noreferrer">隐私政策</a>
        </div>
      </form>
    </div>
  );
};